import React, { Fragment, useState, useEffect, useRef } from "react";
import {
  Card,
  CardTitle,
  Table,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Row,
  Col,
  FormGroup,
  Input,
} from "reactstrap";
import API from "../../redux/actions/API";
import { authHeader } from "../../utils/functions/CoreFunctions";
import Swal from "sweetalert2";
import { GET_WEBFORM_USER } from "../../utils/APIEndpoints";
import { CSVLink } from "react-csv";
import CustomViewButton from "../common/CustomViewButton";
import CustomTableLoader from "../common/CustomTableLoader";
import CustomTableEmptyRecord from "../common/CustomTableEmptyRecord";
import CustomTableHeader from "../common/CustomTableHeader";
import {
  getAlertToast,
} from "../../utils/functions/CustomFunctions";
import View from "../requests/view";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { debounce } from "underscore";
import Pagination from "../common/Pagination";

const tableColumns = [
  { title: "User Name" },
  { title: "Email" },
  { title: "Phone Number" },
  { title: "Submitted Date" },
  { title: "Completed Form" },
  { title: "Additional Documents" },
];

function UserReports(props) {
  const {
    match: {
      params: { id = "" },
    },
  } = props;
  const csvLink = useRef();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [gridData, setGridData] = useState([]);
  const [additionalDocuments, setAdditionalDocuments] = useState({});
  const [viewModal, setViewModal] = useState(false);
  const [dropdownOpen, setdropdownOpen] = useState(false);
  const [csvFile, setCsvFile] = useState([]);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const [filter, setFilter] = useState({
    firstName: "",
    lastName: "",
    email: "",
    startDate: "",
    endDate: "",
    count: 10,
  });
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  //additional Documents Toogle
  const viewToggle = () => setViewModal(!viewModal);

  const viewAdditionalDocuments = async (documents, e) => {
    setAdditionalDocuments(JSON.parse(documents));
    setViewModal(true);
  };

  //filter toogle

  const filterToggle = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  const toggle = () => {
    setdropdownOpen(!dropdownOpen);
  };

  //Onchange filter
  const changeFilterField = ({ target: { name, value } }) => {
    setFilter({ ...filter, [name]: value });
  };

  const startDateChange = (date) => {
    setStartDate(date || "");
    let paymentStartDate = date ? moment(date).format("MM/DD/YYYY") : "";
    setFilter({ ...filter, ["startDate"]: paymentStartDate });
  };

  const endDateChange = (date) => {
    setEndDate(date || "");
    let paymentEndDate = date ? moment(date).format("MM/DD/YYYY") : "";
    setFilter({ ...filter, ["endDate"]: paymentEndDate });
  };

  const handleReset = () => {
    setFilter((val) => ({
      ...val,
      firstName: "",
      lastName: "",
      email: "",
      startDate: "",
      endDate: "",
    }));
  };

  //Excel
  useEffect(() => {
    let data = [
      "First Name",
      "Last Name",
      "Email",
      "Phone Number",
      "Address",
      "City",
      "State",
      "Submited Date",
    ];
    const { userPlaceHolderValue } = gridData[0] || {};
    const replstr =
      userPlaceHolderValue && userPlaceHolderValue.replaceAll("\u0019", "");
    JSON.parse(replstr || "[]").forEach((resultValue) => {
      data.push(resultValue.label);
    });
    setCsvFile((val) => [data]);
  }, [gridData]);

  useEffect(() => {
    if (csvFile.length) {
      gridData.forEach((data) => {
        const {
          firstName,
          lastName,
          email,
          phoneNumber,
          address,
          city,
          state,
          submitDate,
          userPlaceHolderValue,
        } = data;
        let answerValue = [
          firstName,
          lastName,
          email,
          phoneNumber,
          address,
          city,
          state,
          submitDate,
        ];
        const replstr =
          userPlaceHolderValue && userPlaceHolderValue.replaceAll("\u0019", "");
        JSON.parse(replstr || "[]").forEach((resultValue) => {
          const { selectedValue } = resultValue;
          answerValue.push(selectedValue);
        });
        setCsvFile((val) => [...val, answerValue]);
      });
    }
  }, [gridData]);

  const getGridData = async (queryParams) => {
    setLoading(true);
    const options = {
      method: "GET",
      url: GET_WEBFORM_USER,
      headers: authHeader(),
      params: queryParams,
    };
    try {
      const response = await API(options);
      const { status, data, totalCount } = response.data;
      if (status === "Success") {
        setTotalRecords(totalCount);
        setGridData(data);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  //pagination
  const onPageChanged = (page) => {
    setCurrentPage(page - 1);
    getGridData({
      ...filter,
      offset: page - 1,
      agencyServiceId: parseInt(id),
    });
  };

  const handleRowPerPage = ({ target: { name, value } }) => {
    setCurrentPage(0);
    setFilter((val) => ({ ...val, [name]: value || undefined }));
  };

  //debounce
  const delayedQuery = useRef(
    debounce(
      (filter) =>
        getGridData({
          ...filter,
          offset: currentPage,
          agencyServiceId: parseInt(id),
        }),
      500
    )
  ).current;

  useEffect(() => {
    delayedQuery(filter);
  }, [filter]);

  const { firstName, lastName, email, phoneNumber } = filter;
  const csvDownloadFile = async (event, done) => {
    csvLink.current.link.click();
  };
  return (
    <Fragment>
      <Card body className="mt-5">
        <div className="mb-4 tableTitleBg">
          <CardTitle style={{ margin: "0" }}>WebForm User Reports</CardTitle>
          <div className="top-btn">
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
              <DropdownToggle color="danger" caret>
                Export
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem>
                  <Button
                   className="link"
                    onClick={csvDownloadFile}
                    style={{
                      color: "#007bff",
                      border: "none",
                      background: "none",
                      fontSize: "medium",
                    }}
                  >
                    {" "}
                    CSV
                  </Button>
                  <CSVLink
                    filename={"Customers_report.csv"}
                    data={csvFile}
                    ref={csvLink}
                  ></CSVLink>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <i
            className="fas fa-filter"
            style={{
              float: "right",
              margin: "0px 7px 3px 16px",
              fontSize: "19px",
              cursor: "pointer",
            }}
            onClick={filterToggle}
          ></i>
        </div>
        {isFilterOpen && (
          <Row form className="mb-4">
            <Col md={3}>
              <FormGroup>
                <Input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  onChange={changeFilterField}
                  value={firstName}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  onChange={changeFilterField}
                  value={lastName}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Input
                  type="text"
                  name="email"
                  placeholder="Email"
                  onChange={changeFilterField}
                  value={email}
                />
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup>
                <DatePicker
                  style={{ zIndex: "9999 !important", width: "100%" }}
                  selected={startDate}
                  onChange={startDateChange}
                  dateFormat="MM/dd/yyy"
                  maxDate={new Date()}
                  placeholderText="Start Date"
                  className="form-control mb-3"
                  width="100%"
                  popperPlacement="bottom"
                  popperModifiers={{
                    flip: {
                      behavior: ["bottom"],
                    },
                    preventOverflow: {
                      enabled: false,
                    },
                    hide: {
                      enabled: false,
                    },
                  }}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <DatePicker
                  style={{ zIndex: "9999 !important", width: "100%" }}
                  selected={endDate}
                  onChange={endDateChange}
                  dateFormat="MM/dd/yyy"
                  placeholderText="End Date"
                  className="form-control mb-2"
                  minDate={startDate}
                  maxDate={new Date()}
                  // width='100%'
                  popperPlacement="bottom"
                  popperModifiers={{
                    flip: {
                      behavior: ["bottom"],
                    },
                    preventOverflow: {
                      enabled: false,
                    },
                    hide: {
                      enabled: false,
                    },
                  }}
                />
              </FormGroup>
            </Col>
            <Col md={2}>
              <div style={{ marginTop: "4px" }}>
                <Button color="danger" onClick={handleReset}>
                  Reset
                </Button>
              </div>
            </Col>
          </Row>
        )}
        <Table responsive hover>
          {/* Table Header */}
          <CustomTableHeader tableColumns={tableColumns} />
          {/* Table Header */}
          <tbody>
            {loading ? (
              // Table Loader
              <CustomTableLoader columnsCount={tableColumns.length} />
            ) : (
              // Table Loader
              <Fragment>
                {!gridData.length ? (
                  //  Empty Record
                  <CustomTableEmptyRecord columnsCount={tableColumns.length} />
                ) : (
                  //  Empty Record
                  <Fragment>
                    {gridData.map((record, key) => (
                      <tr key={`record_key_${key}`}>
                        <td>
                          {record.firstName} {record.lastName}
                        </td>
                        <td>{record.email}</td>
                        <td>{record.phoneNumber}</td>
                        <td>{record.submitDate}</td>
                        <td style={{ width: "100px", textAlign: "center" }}>
                          {record.documentUrl ? (
                            <a href={record.documentUrl} target="_blank">
                              <Button className="action-btn" color="success">
                                <span className="fas fa-download"></span>
                              </Button>
                            </a>
                          ) : (
                            ""
                          )}
                        </td>
                        <td style={{ width: "100px", textAlign: "center" }}>
                          {/* Custom View Button  */}
                          {record.additionalDocuments ? (
                            <CustomViewButton
                              keyvalue={key}
                              onClick={(e) =>
                                viewAdditionalDocuments(
                                  record.additionalDocuments,
                                  e
                                )
                              }
                            />
                          ) : (
                            ""
                          )}
                          {/* Custom View Button  */}
                        </td>
                      </tr>
                    ))}
                  </Fragment>
                )}
              </Fragment>
            )}
          </tbody>
          {/* Table Body */}
        </Table>
        {gridData.length ? (
          <div className="d-flex py-4 justify-content-end space_between">
            <div className="space_between">
              <div>
                <p className="per_page">Records/Page</p>
              </div>
              <div>
                <FormGroup>
                  <Input
                    className="pagi_drop"
                    type="select"
                    name="count"
                    onChange={handleRowPerPage}
                    value={filter.count}
                  >
                    <option value={""}>Show All</option>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Input>
                </FormGroup>
              </div>
            </div>
            {filter.count && (
              <div>
                <Pagination
                  itemClass="page-item"
                  linkClass="page-link"
                  activePage={currentPage + 1}
                  itemsCountPerPage={filter.count}
                  totalItemsCount={totalRecords}
                  onChange={onPageChanged}
                />
              </div>
            )}
          </div>
        ) : (
          ""
        )}
      </Card>
      {/* View Dialog */}
      {viewModal && (
        <View
          data={additionalDocuments}
          viewToggle={viewToggle}
          viewModal={viewModal}
        />
      )}
    </Fragment>
  );
}

export default UserReports;
